import { HyperBackendMethod } from "@shared/backend/hyper-backend-method";
import { Roles } from "@shared/Roles";
import { Controller, remult, repo, type EntityFilter } from "remult";
import type { NotificationBase } from "../notification-base";
import { OrganizationManagerNotification } from "./entity";

@Controller("organization-manager-notification-methods")
export class OrganizationManagerNotificationMethods {
  @HyperBackendMethod({
    allowed: Roles.AdminsAndManager,
    overrideSecurity: true,
  })
  static async markAsRead(where: EntityFilter<NotificationBase>) {
    await repo(OrganizationManagerNotification).updateMany({
      where: {
        $and: [
          {
            toId: remult.user!.id,
            hasRead: false,
          },
          where,
        ],
      },
      set: {
        hasRead: true,
      },
    });
  }
}
